/**
 * @vuelto-surface
 * mobile: ok
 * desktop: ok
 * strategy: inherit
 */
import React from 'react';
import { StyleSheet, Text, View, type StyleProp, type ViewStyle } from 'react-native';
import { ticketColors } from '../../../shared/theme/ticketColors';
import { formatSupportUnreadBadgeCount } from './supportUnreadPresentation';

type BadgeVariant = 'overlay' | 'inline';

type Props = {
  count: number;
  variant?: BadgeVariant;
  style?: StyleProp<ViewStyle>;
};

export function SupportUnreadBadge({ count, variant = 'overlay', style }: Props) {
  if (count <= 0) return null;

  return (
    <View
      style={[
        variant === 'overlay' ? styles.overlayBadge : styles.inlineBadge,
        style,
      ]}
      accessibilityElementsHidden
    >
      <Text style={styles.badgeText} numberOfLines={1}>
        {formatSupportUnreadBadgeCount(count)}
      </Text>
    </View>
  );
}

type IconAnchorProps = {
  count: number;
  children: React.ReactNode;
  style?: StyleProp<ViewStyle>;
  badgeStyle?: StyleProp<ViewStyle>;
};

/** Contenedor relativo para superponer el badge sobre un ícono (tab Más, filas del hub). */
export function SupportUnreadIconAnchor({ count, children, style, badgeStyle }: IconAnchorProps) {
  return (
    <View style={[styles.iconAnchor, style]}>
      {children}
      <SupportUnreadBadge count={count} variant="overlay" style={badgeStyle} />
    </View>
  );
}

const styles = StyleSheet.create({
  iconAnchor: {
    position: 'relative',
  },
  overlayBadge: {
    position: 'absolute',
    top: -4,
    right: -4,
    minWidth: 16,
    height: 16,
    paddingHorizontal: 4,
    borderRadius: 8,
    backgroundColor: ticketColors.bad,
    alignItems: 'center',
    justifyContent: 'center',
  },
  inlineBadge: {
    minWidth: 18,
    height: 18,
    paddingHorizontal: 5,
    borderRadius: 9,
    backgroundColor: ticketColors.bad,
    alignItems: 'center',
    justifyContent: 'center',
  },
  badgeText: {
    color: ticketColors.bg,
    fontSize: 10,
    fontWeight: '800',
  },
});
